/*
 * @Autor: yingna.gao
 * @Date: 2022-11-04 14:33:38
 * @LastEditTime: 2022-12-21 19:20:31
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/api/report-config/index.js
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  // 列表
  getDynamicReportlist: params => request({
    url: `${requestUrl}/dynamic-report/page`,
    method: "get",
    params
  }),
  // 保存动态报表
  saveDynamicReport: data => request({
    url: `${requestUrl}/dynamic-report`,
    method: "post",
    data
  }),
  // 更新动态报表
  updateDynamicReport: data => request({
    url: `${requestUrl}/dynamic-report`,
    method: "put",
    data
  }),
  // 删除动态列表
  deleteDynamicReport: data => request({
    url: `${requestUrl}/dynamic-report/delete-batch`,
    method: "post",
    data
  }),
  // 根据客户查询对应角色
  getReportDetails: params => request({
    url: `${requestUrl}/dynamic-report/detail`,
    method: "get",
    params
  }),
  // 根据客户角色查询对应菜单
  getConfigSearch(params) {
    return request({
      url: `${requestUrl}/dynamic-report/query/filter-param`,
      method: "get",
      params
    });
  },

  // 根据租户查找分配菜单
  getDynamicReportList: ({ query, body }) => request({
    url: `${requestUrl}/dynamic-report/execute-query?page=${query.page}&size=${query.size}`,
    method: "post",
    data: body
  }),
  // sql表达式测试格式
  testSql: data => request({
    url: `${requestUrl}/dynamic-report/test-query`,
    method: "post",
    data
  }),
  executeReportExport: data => request({
    url: `${requestUrl}/dynamic-report/execute-export`,
    method: "post",
    data
  }),
  allotUserToOrg: params => request({
    url: `${requestUrl}/tenant/shareOtherOrg`,
    method: "put",
    params
  })
};

export default api;
